function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["name", "required", "as", "helpText", "validate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useContext } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useController } from 'react-hook-form';
import { FormSymbolContext } from "../Form/Form.context";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function createFieldComponent(_ref) {
  var formSymbol = _ref.formSymbol,
    FormContext = _ref.FormContext;
  function Field(_ref2) {
    var _fieldState$error;
    var name = _ref2.name,
      required = _ref2.required,
      as = _ref2.as,
      helpText = _ref2.helpText,
      validate = _ref2.validate,
      rest = _objectWithoutProperties(_ref2, _excluded);
    var formSymbolContext = useContext(FormSymbolContext);
    var context = useContext(FormContext);
    if (!formSymbolContext) {
      throw new Error('Field must be rendered inside Form');
    }
    if (formSymbolContext !== formSymbol) {
      throw new Error("All Field's inside Form must be created by the same createForm function");
    }
    if (!context) {
      throw new Error('Field must be rendered inside Form');
    }
    var _context$context = context.context,
      getValues = _context$context.getValues,
      trigger = _context$context.trigger,
      control = _context$context.control;
    assertNameIsValid(name, getValues);

    // FIXME: Can't figure out how to fix this but it should be fine at runtime
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var _useController = useController({
        name: name,
        control: control,
        rules: {
          required: required,
          validate: validate && function (value) {
            var result = validate(value, {
              values: getValues(),
              triggerValidation: function triggerValidation(fieldName) {
                if (typeof fieldName !== 'string') {
                  throw new Error('fieldName must be a string');
                }

                // @ts-expect-error Will be fine at run-time
                trigger(fieldName);
              }
            });
            // @ts-expect-error run-time prop type check
            if (result === false) {
              throw new Error('`validate` must return a string if invalid');
            }
            return result;
          }
        }
      }),
      field = _useController.field,
      fieldState = _useController.fieldState;

    // @ts-expect-error run-time prop type check
    if (required === true) {
      throw new Error('`required` should be either false or type of string.');
    }

    // FIXME: Find a way to avoid the type assertion below
    var FormControl = as;
    function isForwardRef(FormControl) {
      // @ts-expect-error https://github.com/facebook/react/blob/c54e3541b2fb6251bd7cd399e77037220b47de2e/fixtures/legacy-jsx-runtimes/react-15/cjs/react-jsx-dev-runtime.development.js#L54
      return FormControl.$$typeof === Symbol["for"]('react.forward_ref');
    }
    return _jsx(FormControl, _objectSpread(_objectSpread({}, rest), {}, {
      // FIXME: Can't figure out how to fix this but it should be fine at runtime
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      value: field.value,
      onChange: function onChange(value) {
        assertNameIsValid(name, getValues);

        // While FormControl.onChange should be an event and batched by
        // default, there could be a case where some custom component calls it
        // asynchronously, in which case these 2 calls won't be batched by
        // default.  To be safe, let's wrap it in unstable_batchedUpdates so
        // they batch.  For more info, see:
        // https://github.com/ApplyBoard/platform_monorepo_ui/blob/690eb04dabc146a5980b6aaf2b05c56f26f8420c/packages/crystal-ui/src/components/Form/Form.hooks.ts#L58
        unstable_batchedUpdates(function () {
          var _rest$onChange;
          (_rest$onChange = rest.onChange) === null || _rest$onChange === void 0 ? void 0 : _rest$onChange.call(rest, value);
          field.onChange({
            target: {
              name: name,
              value: value
            }
          });
        });
      },
      onBlur: function onBlur() {
        unstable_batchedUpdates(function () {
          var _rest$onBlur;
          (_rest$onBlur = rest.onBlur) === null || _rest$onBlur === void 0 ? void 0 : _rest$onBlur.call(rest);
          field.onBlur();
        });
      },
      onFocus: function onFocus() {
        var _rest$onFocus;
        (_rest$onFocus = rest.onFocus) === null || _rest$onFocus === void 0 ? void 0 : _rest$onFocus.call(rest);
      },
      ref: isForwardRef(FormControl) ? field.ref : undefined,
      invalid: Boolean(fieldState.error),
      helpText: typeof ((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message) === 'string' ? fieldState.error.message : helpText,
      required: Boolean(required)
    }));
  }
  return Field;
}

/**
 * Asserts that the name either has no dots, 1 dot, or 2 dots.  Also the text between
 * the 2 dots should be a number.  For example, these are valid names:
 * ```
 * "color"
 * "items.0.color"
 * "items.0"
 * ```
 * While these are invalid names:
 * ```
 * "items."
 * "items.a"
 * "items.0."
 * ```
 */
function assertNameIsValid(name, getValues) {
  if (name.indexOf('.') > -1) {
    var parts = name.split('.');
    if (parts.length > 3) {
      throw new Error('Must follow the format {string.number.string} or {string.number} when using dots in names');
    }
    var index = Number(parts[1]);
    if (isNaN(index)) {
      throw new Error('Must follow the format {string.number.string} or {string.number} when using dots in names');
    }
    if (!parts[0] || parts.length === 3 && !parts[2]) {
      throw new Error('Must follow the format {string.number.string} or {string.number} when using dots in names');
    }
    var arr = getValues()[parts[0]];
    if (!Array.isArray(arr) || !arr[index]) {
      throw new Error('Tried to render a Field for an array element that does not exist');
    }
  }
}